import {useRef} from "react";
import {useNextForm} from "@cdx/common/forms-next/FormNext";
import {TextField} from "@cdx/common/forms-next/fields";
import {DSFieldSetClassName} from "@cdx/ds";
import {refusalReason} from "../../lib/mutation-refusal";
import {isCompleteTotpCode, totpCodeSchema} from "./totp-code";
import {describeSecurityError} from "./webauthn-browser";

type TotpCodeFormProps = {
  verify: (code: string) => Promise<unknown>;
  onDone: () => void;
  buttonLabel: string;
};

/**
 * The code field of the login step and of the re-verification dialog. It submits at 6 digits, so a
 * password manager's fill goes straight through.
 */
export const TotpCodeForm = ({verify, onDone, buttonLabel}: TotpCodeFormProps) => {
  const isSubmittingRef = useRef(false);
  const {Form, field, triggerSubmit} = useNextForm({
    initial: {code: ""},
    schema: totpCodeSchema,
    onSubmit: ({code}) => {
      isSubmittingRef.current = true;
      return verify(code)
        .finally(() => (isSubmittingRef.current = false))
        .then(onDone, (e) =>
          Promise.reject(
            refusalReason(e) === "invalid_totp_code"
              ? {code: describeSecurityError(e)}
              : describeSecurityError(e)
          )
        );
    },
  });
  const handleChange = (next: string) => {
    if (isCompleteTotpCode(next) && !isSubmittingRef.current) triggerSubmit();
  };
  return (
    <Form buttonLabel={buttonLabel} className={DSFieldSetClassName}>
      <TextField
        field={field("code")}
        label="Code from your authenticator app"
        placeholder="123456"
        autoComplete="one-time-code"
        inputMode="numeric"
        onChange={handleChange}
        autoFocus
      />
    </Form>
  );
};
